export default {
  name: "ModalTransactionGet",
  props: {
    transaction: {
      type: Object,
      required: true
    },
    showModal:{
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default(){
        return "Detalhes da transação";
      }
    },
    isLoading: {
      type: Boolean
    }
  },
  data() {
    return {
      infoTransaction: this.transaction,
      relatedTransactions: this.relatedTransactions,
      isSeeing: true,
      mSteps: ["Cliente", "Pagamento", "Produto", "Histórico", "Splits", "Informações Adicionais", "Correlações"],
      mCurrentStep: 0,
      modalModel: this.showModal,
      loadingNewTransaction: false,
      loadingTransactionRelated: false
    };
  },
  watch: {
    "modalModel"(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue == true) {
          this.ShowModal();
        } else {
          this.HideModal();
        }
      }
    },
    "transaction.Id"(newValue, oldValue) {
      if (newValue != oldValue) {
        this.infoTransaction = this.transaction;
        this.mCurrentStep = 0;
      }
    },
    "isLoading"(newValue) {
      if (newValue != true) {
        this.mCurrentStep = 0;
      }
    }
  },
  computed: {
    showLoading() {
      return this.isLoading || this.loadingNewTransaction;
    },
    isValidComponent() {
      return this.infoTransaction != undefined && this.infoTransaction != null;
    },
    idTransaction() {
      return this.infoTransaction.Id;
    },
    GetClass() {
      if (this.infoTransaction != null && this.infoTransaction.Id > 0) {
        switch (this.infoTransaction.TransactionStatus.Code) {
          case "1":
            return "labelModal labelsecondary";
          case "2":
          case "5":
          case "6":
          case "12":
          case "19":
            return "labelModal labelwarning";
          case "11":
          case "14":
            return "labelModal labelinfo";
          case "3":
            return "labelModal labelsuccess";
          case "4":
            break;
          case "7":
          case "8":
          case "13":
            return " labelModal labeldanger";
        }
      }
    }
  },
  methods: {
    ShowModal() {
      this.mCurrentStep = 0;
      this.modalModel = true;
      this.$emit("update:showModal", true);
    },
    HideModal() {
      this.infoTransaction = null;
      this.relatedTransactions = null;
      this.modalModel = false;
      this.$emit("update:showModal", false);
    },
    ChangeGet(idTransaction, idMerchant) {
      this.mCurrentStep = 0;
      this.GetTransaction(idTransaction, idMerchant);
    },
    GetTransaction(id, idMerchant) {
      this.loadingNewTransaction = true;
      this.$store
        .dispatch("GetTransaction", { id: id, idMerchant: idMerchant })
        .then(response => {
          this.infoTransaction = response;
          if (response.Id > 0) {
            this.ListCreditCardRefused();
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da transação.", error);
          this.HideModal();
        })
        .finally(() => {
          this.loadingNewTransaction = false;
          this.ListCreditCardRefused();
        });
    },
    ListCreditCardRefused() {
      const todayDate = new Date().toISOString().slice(0, 10);
      const lastMonth = new Date(todayDate);
      lastMonth.setMonth(lastMonth.getMonth() -1);
      this.loadingTransactionRelated = true;
      this.$store
        .dispatch("ListCreditCardRefused", { "Object.Customer.Identity": this.infoTransaction.Customer.Identity, "CreatedDateInitial": lastMonth })
        .then(response => {
          this.relatedTransactions = response.Objects;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro ao listar as transações relacionadas", error))
        .finally(() => {
          this.loadingTransactionRelated = false;
        });
    },
    ProcessNextStep(nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
    },
    NextStep() {
      if (this.mCurrentStep < this.mSteps.length - 1) {
        if (this.mCurrentStep == 3 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep += 2;
        } else this.mCurrentStep += 1;
      }
    },
    BackStep() {
      if (this.mCurrentStep >= 1) {
        if (this.mCurrentStep == 5 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep -= 2;
        } else this.mCurrentStep -= 1;
      }
    },
    GoToStep(e, stepToGo) {
      e.preventDefault();

      if (stepToGo <= this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    ComputeExpirationPix(CreatedDate, Expiration){
      const expirationDate = new Date(CreatedDate);
      expirationDate.setSeconds(expirationDate.getSeconds() + Expiration);
      return expirationDate;
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/sub-components/Generic/ModalTransactionGet/ModalTransactionGet.js